import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  constructor(private httpService: HttpService) {}

  public getBrands(filterData: object): Observable<BrandDto> {
    return this.httpService.postHttp<BrandDto>(
      Constants.ServiceConstants.BRANDS,
      filterData
    );
  }
}
